import { Component } from '@angular/core';

@Component({
  selector: 'di-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  standalone: false,
})
export class ErrorComponent {}
